// extracted by mini-css-extract-plugin
export default {"factors":"Factor_factors__QYpFu","factor":"Factor_factor__KobPd","arrow":"Factor_arrow__XalVI"};